export default [
    {
        // [0]
        key: "personal_name",
        label: "Personal",
        visible: true,
    },
    {
        // [1]
        key: "ut_type",
        label: "UT Type",
        visible: true,
    },
    {
        // [2]
        key: "is_viatic",
        label: "Viatic",
        visible: true,
    },
    {
        // [3]
        key: "coordinator",
        label: "Coordinator",
        visible: false,
    },
    {
        // [4]
        key: "entity_group_name",
        label: "entity group",
        visible: true,
    },
    {
        // [5]
        key: "viatic_status",
        label: "Viatic Status",
        visible: true,
    },
    {
        // [6]
        key: "monday",
        label: "mon",
        visible: true,
    },
    {
        // [7]
        key: "tuesday",
        label: "tue",
        visible: true,
    },
    {
        // [8]
        key: "wednesday",
        label: "wed",
        visible: true,
    },
    {
        // [9]
        key: "thursday",
        label: "thu",
        visible: true,
    },
    {
        // [10]
        key: "friday",
        label: "fri",
        visible: true,
    },
    {
        // [11]
        key: "saturday",
        label: "sat",
        visible: true,
    },
    {
        // [12]
        key: "sunday",
        label: "sun",
        visible: true,
    },
    {
        // [13]
        key: "viatic_amount",
        label: "Amount",
        visible: true,
    },
    {
        // [14]
        key: "actions",
        label: "Actions",
        visible: true,
        tdClass: "text-center"
    },
]